<template>
  <div class="relative inline-block text-left">
    <button 
      @click="toggleDropdown" 
      :class="[darkMode ? 'text-gray-400 hover:text-white' : 'text-gray-600 hover:text-gray-900', 'flex items-center text-sm font-medium focus:outline-none transition']"
    >
      <span>{{ currentLanguage }}</span>
      <svg 
        :class="[darkMode ? 'text-gray-400' : 'text-gray-500', 'ml-1 h-5 w-5']" 
        xmlns="http://www.w3.org/2000/svg" 
        viewBox="0 0 20 20" 
        fill="currentColor"
      >
        <path 
          fill-rule="evenodd" 
          d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" 
          clip-rule="evenodd" 
        />
      </svg>
    </button>

    <div 
      v-if="isOpen" 
      :class="[darkMode ? 'bg-gray-800 ring-gray-700' : 'bg-white ring-black', 'origin-top-center absolute top-full mt-2 w-32 rounded-md shadow-lg ring-1 ring-opacity-5 z-10']"
    >
      <div class="py-1">
        <button
          v-for="locale in availableLocales"
          :key="locale.code"
          @click="changeLocale(locale.code)"
          :class="[darkMode ? 'text-gray-400 hover:text-white hover:bg-gray-700' : 'text-gray-700 hover:bg-gray-100', 'w-full text-left block px-4 py-2 text-sm transition']"
        >
          {{ locale.name }}
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, onUnmounted } from 'vue'
import { useI18n } from 'vue-i18n'
import { useLanguageStore } from '../../stores/language.js'

const props = defineProps({
  darkMode: {
    type: Boolean,
    default: false
  }
})

const { t } = useI18n()
const langStore = useLanguageStore()

const isOpen = ref(false)

const availableLocales = computed(() => langStore.availableLanguages || [])

const currentLanguage = computed(() => {
  const language = langStore.availableLanguages.find(lang => lang.code === langStore.currentLang)
  return language ? language.name : langStore.currentLang
})

function toggleDropdown() {
  isOpen.value = !isOpen.value
}

function changeLocale(locale) {
  langStore.setLanguage(locale)
  isOpen.value = false
}

// Close dropdown when clicking outside
function handleClickOutside(event) {
  if (isOpen.value && !event.target.closest('.relative')) {
    isOpen.value = false
  }
}

onMounted(() => {
  document.addEventListener('click', handleClickOutside)
})

onUnmounted(() => {
  document.removeEventListener('click', handleClickOutside)
})
</script>